<template>
  <b-table :data="logs"
           :loading="loading"
           :striped="true">
      <b-table-column field="timestamp" label="Time" v-slot="props" centered>{{(new Date(props.row.timestamp * 1000)).toLocaleString()}}</b-table-column>
      <b-table-column field="level" label="Level" v-slot="props" >{{props.row.level}}</b-table-column>
      <b-table-column field="log" label="Log" v-slot="props" >{{props.row.log}}</b-table-column>
    <template slot="empty">
      <section class="section">
        <div class="content has-text-grey has-text-centered">
            <p>
                <b-icon
                    icon="emoticon-sad"
                    size="is-large">
                </b-icon>
            </p>
            <p>Nothing here.</p>
        </div>
      </section>
    </template>
  </b-table>
</template>

<script>
import { api } from '../main.js'
export default {
  data: function () {
    return {
      logs: [],
      loading: true
    }
  },
  props: ['device'],
  mounted: function () {
    this.loading = true
    this.logs = []
    api.get('device/' + this.device + '/logs')
      .then(result => {
        this.logs = result.data
        this.loading = false
      })
  }
}
</script>
